export const API_URL = process.env.REACT_APP_API_URL
export const CHARGEBEE_SITE =
  process.env.NODE_ENV === 'production' ? 'shopandshout' : 'shopandshout-test'
export const IDM_URL = process.env.REACT_APP_IDM_URL
export const AUTH_DASHBOARD_DOMAIN = process.env.REACT_APP_AUTH_DASHBOARD_DOMAIN
export const HELP_CENTER_URL = 'https://creator8882.zendesk.com/hc/en-us'
export const PHYLLO_INSTAGRAM_DIRECT_PLATFORM_ID = 'd3badb09-a81f-4444-bc27-1a994d939e00'
export const PHYLLO_INSTAGRAM_PLATFORM_ID = '9bb8913b-ddd9-430b-a66a-d74d846e6c66'
export const PHYLLO_TIKTOK_PLATFORM_ID = 'de55aeec-0dc8-4119-bf90-16b3d1f0c987'
export const PHYLLO_YOUTUBE_PLATFORM_ID = '14d9ddf5-51c6-415e-bde6-f8ed36ad7054'
